import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const CHUNK_ERROR_PATTERNS = [
  "Failed to fetch dynamically imported module",
  "Loading chunk",
  "Importing a module script failed",
  "Unable to preload CSS",
];

function isChunkError(err: unknown): boolean {
  if (!(err instanceof Error)) return false;
  return CHUNK_ERROR_PATTERNS.some((p) => err.message.includes(p));
}

const STORAGE_KEY = "chunk-reload-once";

export function lazyWithChunkReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((err: unknown) => {
      if (isChunkError(err)) {
        if (!sessionStorage.getItem(STORAGE_KEY)) {
          sessionStorage.setItem(STORAGE_KEY, "1");
          window.location.reload();
          return new Promise<never>(() => {});
        }
      }
      throw err;
    })
  );
}
